import React from 'react';
import nextId from '../../services/NextID.service';
import DateSelector from '../dateSelector/DateSelectorController';
// import './widget.css';

function renderSelect(config) {
	const { propertyName = 'selectedLessonType', placeholderText = 'Choose your Lesson Type', data = [], onChange, selectedValue } = config;
	return (
		<div key={nextId()}>
			<select name={propertyName} className="select" value={selectedValue} onChange={(e) => onChange(e)} required>
				<option value="" disabled>{placeholderText}</option>
				{data.map(res => { return <option key={nextId()} value={res.id}>{res.name}</option> })}
			</select>
		</div>
	);
}

function renderDate(config) {
	const { propertyName = 'startDate', minDate = new Date().toISOString().substr(0, 10), placeholderText = 'date', onChange, selectedValue } = config;
	if (window.__desktop_safari_detected) {
		return <DateSelector name={propertyName} value={selectedValue} required min={minDate} placeholder={placeholderText} onChange={onChange} />;
	}
	return (
		<input name={propertyName} className="date" type="date" value={selectedValue} required min={minDate} placeholder={placeholderText} onChange={(e) => onChange(e)} />
	);
}

class WidgetView extends React.Component {
	render() {
		const { resorts, lessonTypes, onSubmit, onChange, partnerId, selectedResort, selectedLessonType, dateEnd, dateStart } = this.props;

		return (
			<form onSubmit={(e) => onSubmit(e)}>
			<style>{`
			  .select{
				-webkit-appearance: button;
				-webkit-border-radius: 2px;
				-webkit-box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1);
				-webkit-padding-end: 20px;
				-webkit-padding-start: 2px;
				-webkit-user-select: none;
				background-image: url(http://i62.tinypic.com/15xvbd5.png), -webkit-linear-gradient(#FAFAFA, #F4F4F4 40%, #E5E5E5);
				background-position: 97% center;
				background-repeat: no-repeat;
				border: 1px solid #AAA;
				color: #555;
				font-size: inherit;
				margin: 10px;
				overflow: hidden;
				padding: 5px 10px;
				text-overflow: ellipsis;
				white-space: nowrap;
				width: 300px;
				height: 36px;
			 }
			
			input, textarea {
			  background: #fff;
			  outline: none;
			  resize: none;
			  font-family: "Lato", sans-serif;
			  font-weight: 400;
			  padding: 4px 10px;
			  font-size: 13px;
			  line-height: 22px;
			  border-radius: 3px;
			  }
			
			  .styled-select select {
				background: transparent;
				width: 268px;
				padding: 5px;
				font-size: 16px;
				line-height: 1;
				border: 0;
				border-radius: 0;
				height: 34px;
				-webkit-appearance: none;
			  }
			
			
			  .styled-select {
				width: 240px;
				height: 34px;
				overflow: hidden;
				background: url('/new_arrow.jpg') no-repeat right #ddd;
				border: 1px solid #ccc;
				background-color: #EAE7E7;
				margin: 10px;
				border: 1px solid #777D88;
				width: 300px;
			  }  
			 
			
			.date, .date-selector-dateEnd, .date-selector-dateStart {
				/* -webkit-appearance: button;
				-webkit-border-radius: 2px;
				-webkit-box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1);
				-webkit-padding-end: 20px;
				-webkit-padding-start: 2px;
				-webkit-user-select: none; */
				background-image: url(http://i62.tinypic.com/15xvbd5.png), -webkit-linear-gradient(#FAFAFA, #F4F4F4 40%, #E5E5E5);
				background-position: 97% center;
				background-repeat: no-repeat;
				border: 1px solid #AAA;
				color: #555;
				font-size: inherit;
				margin: 10px;
				overflow: hidden;
				padding: 5px 10px;
				text-overflow: ellipsis;
				white-space: nowrap;
				width: 279px;
			}	
			
			/* This block hides the defult text o fthe date field "yyyy/mm/dd", unless it has a valid date */
			input[type="date"]:invalid::before{
				color:#555;
				content: attr(placeholder) "";
			 }
			 input[type="date"]:focus::before {
				content: "" !important;
			 }
			 input[type="date"]:invalid {
				color: transparent;
			}
			input[type=date]:focus::-webkit-datetime-edit {
				color: #555 !important;
			}
			
			.partner-id {
				text-align: right;
			}
			
			.lgoo {
				width: 250px;
			}
			
			.controls {
				width: 300px;
				position: relative;
				margin-left: 30px;
			}
			.button {
				background: #d2232a;
				font-weight: 400;
				border: 1px solid transparent;
				width: 300px;
				text-transform: uppercase;
				white-space: normal;
				min-height: 50px;
				margin: 10px;
				font-size: 1.2em;
				color: white;
				border-radius: 5px;
			}
			
			.dp-modal .dp:before {
				background-color: #d2232a !important;
			}
			`}</style>
				<div>
					<img className="logo" alt="SkiBro logo" src="https://storage.googleapis.com/skibro-static/website/images/skibro-lg-logo-shadow.png" />
				</div>
				<div className="controls">
					<div className="row">
						<div className="col-md-12">
							{renderSelect({ data: resorts, placeholderText: 'Choose your resort', propertyName: 'selectedResort', selectedValue: selectedResort, onChange })}
						</div>
					</div>
					<div className="row">
						<div className="col-md-12">
							{renderSelect({ data: lessonTypes, placeholderText: 'Choose your Lesson Type', propertyName: 'selectedLessonType', selectedValue: selectedLessonType, onChange })}
						</div>
					</div>
					<div className="row">
						<div className="col-md-12">
							<div className="date-holder">
								{renderDate({ propertyName: 'dateStart', placeholderText: 'Start Date', selectedValue: dateStart, onChange })}
							</div>
						</div>
					</div>
					<div className="row">
						<div className="col-md-12">
							<div className="date-holder">
								{renderDate({ propertyName: 'dateEnd', placeholderText: 'End Date', selectedValue: dateEnd, onChange })}
							</div>
						</div>
					</div>

					<div>
						<button
							type="submit"
							id="homepage_search_submit"
							name="homepage_search"
							className="btn-primary btn button">book your experience</button>
					</div>
				</div>
				<div className="partner-id">{partnerId}</div>
			</form>
		);
	}
}

export default WidgetView;


// WEBPACK FOOTER //
// ./src/components/widget/WidgetView.js